import { i18nt } from '../../root';

import { NSC_RT } from './namespaces';

export const RT_TEXT_OVERWRITE = {
  previousText: i18nt('previousText', { ns: NSC_RT }),
  nextText: i18nt('nextText', { ns: NSC_RT }),
  loadingText: i18nt('loadingText', { ns: NSC_RT }),
  noDataText: i18nt('noDataText', { ns: NSC_RT }),
  pageText: i18nt('pageText', { ns: NSC_RT }),
  ofText: i18nt('ofText', { ns: NSC_RT }),
  rowsText: i18nt('rowsText', { ns: NSC_RT })
};
